import { Box, Text, Tooltip } from "@mantine/core"
import { useHelp } from "@dehub/theme"
import { ReactNode } from "react"

/**
 * Column header with the two-line help tooltip (`field.col-*`: summary + what), the same markup as
 * `ListHead` in purchase-sales/list-table. Plain label without content (R10, @dehub/help).
 */
export function HelpColumnTitle({ helpKey, children }: Readonly<{ helpKey: string; children: ReactNode }>) {
  const { t } = useHelp()
  const body = t(helpKey)?.body as { summary?: string; what?: string } | undefined
  const tip = body?.summary ? (
    <Box>
      <Text fz={13} inherit>
        {body.summary}
      </Text>
      {body.what && (
        <Text fz={13} mt={4} opacity={0.85} inherit>
          {body.what}
        </Text>
      )}
    </Box>
  ) : null
  return (
    <Tooltip label={tip} disabled={!tip} multiline w={340} withArrow openDelay={300} position="bottom-start">
      <Text span inherit style={tip ? { textDecoration: "underline dotted", textUnderlineOffset: 3, cursor: "help" } : undefined}>
        {children}
      </Text>
    </Tooltip>
  )
}
